import { render, staticRenderFns } from "./edit-camera.vue?vue&type=template&id=72f45c12&"
import script from "./edit-camera.vue?vue&type=script&lang=js&"
export * from "./edit-camera.vue?vue&type=script&lang=js&"
import style0 from "./edit-camera.vue?vue&type=style&index=0&id=72f45c12&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports